/**
 *
 * @param columns
 * @param excludedColumns
 * @returns {*[]|*}
 */
export const mapMUITableColumnsToFilterColumns = (
  columns,
  excludedColumns = []
) => {
  if (!columns || !columns.length) {
    return [];
  }

  return columns
    .filter(col => excludedColumns && !excludedColumns.includes(col.label))
    .map(col => ({ Header: col.label, id: col.name }));
};
